import { cls } from "../components/Utility";
import reception from "../assets/pictures/home/home_reception.webp";
import home1 from "../assets/videos/home55.webm";
import home2 from "../assets/videos/home22.webm";
import logo from "../assets/logos/RG copy 2.png";
import international from "../assets/pictures/home/home_international.webp";
import wedding from "../assets/pictures/home/home_wedding33.webp";
import prewedding from "../assets/pictures/home/home_prewedding22.webp";
import { Link } from "react-router-dom";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Home() {
  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full overflow-hidden">
          {/* Video Background */}
          <div className="w-full h-[750px]">
            <video className="w-full h-[750px] object-cover" autoPlay loop muted>
              <source src={home1} type="video/mp4" />
            </video>
          </div>

          {/* Overlay Text */}
          <div className="absolute  inset-x-0 bottom-[90px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp">
                AUTHENTIC X LOVE STORIES
              </h1>

              <Link to="/authentic-x-love-stories">
                <button className="mt-[30px] text-[16px] rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                  EXPLORE
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          {/* Video Background */}
          <div className="w-full h-full">
            <video
              className="w-full h-[600px] object-cover"
              autoPlay
              loop
              muted
            >
              <source src={home1} type="video/mp4" />
            </video>
          </div>

          {/* Overlay Text */}
          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest fadeInUp">
                AUTHENTIC X LOVE STORIES
              </h1>

              <Link to="/authentic-x-love-stories">
                <button className="mt-[30px] text-[16px] rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                  EXPLORE
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <p
        className={cls(
          "text-center mt-[40px] mb-[40px] text-[14px] font-[description1] pl-[20px] pr-[20px]",
          "xl:mt-[50px] xl:mb-[50px] xl:pl-0 xl:pr-0 xl:text-[14px]"
        )}
      >
        “Every frame is a timeless legacy waiting to be unveiled.”
      </p>

      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={wedding} />
          </div>
          <div className="absolute  inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest">
                WEDDINGS
              </h1>

              <Link to="/weddings">
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        {" "}
        <div className="relative w-full overflow-hidden">
          <img src={wedding} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[360px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest">
                WEDDINGS
              </h1>

              <Link to="/weddings">
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div className="relative w-full h-screen overflow-hidden mt-[40px] mb-[40px]">
          <div className="w-full h-full">
            <img src={international} />
          </div>

          <div className="absolute  inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest">
                CINEMATIC INTERNATIONAL SHOOTS
              </h1>

              <Link to="/international-shoots">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        {" "}
        <div className="relative w-full overflow-hidden mt-[40px] mb-[40px]">
          <img src={international} className="w-full h-[500px] object-cover" />

          <div className="absolute  inset-x-0 top-[330px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest">
                CINEMATIC INTERNATIONAL SHOOTS
              </h1>

              <Link to="/international-shoots">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <video className="w-full h-full object-cover" autoPlay loop muted>
              <source src={home2} type="video/mp4" />
            </video>
          </div>

          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp">
                CONCEPT X CREATIVITY
              </h1>

              {/* <Link to="/concept-creativity">
                <button className="mt-[30px] text-[16px] rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                  EXPLORE
                </button>
              </Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        {" "}
        <div className="relative w-full overflow-hidden">
          <div className="w-full h-full">
            <video
              className="w-full h-[500px] object-cover"
              autoPlay
              loop
              muted
            >
              <source src={home2} type="video/mp4" />
            </video>
          </div>

          <div className="absolute inset-x-0 top-[360px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest fadeInUp">
                CONCEPT X CREATIVITY
              </h1>

              {/* <Link to="/concept-creativity">
                <button className="mt-[30px] text-[16px] rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                  EXPLORE
                </button>
              </Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div className="relative w-full h-screen overflow-hidden mt-[40px] mb-[40px]">
          <div className="w-full h-full">
            <img src={prewedding} />
          </div>

          <div className="absolute  inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest">
                PRE-WEDDINGS
              </h1>

              <Link to="/preweddings">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        {" "}
        <div className="relative w-full overflow-hidden mt-[40px] mb-[40px]">
          <img src={prewedding} className="w-full h-[500px] object-cover" />

          <div className="absolute  inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest">
                PRE-WEDDINGS
              </h1>

              <Link to="/preweddings">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div className="relative w-full h-screen overflow-hidden mb-[40px]">
          <div className="w-full h-full">
            <img src={reception} />
          </div>

          <div className="absolute  inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest">
                CELEBRATIONS
              </h1>

              <Link to="/receptions">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        {" "}
        <div className="relative w-full overflow-hidden mb-[40px]">
          <img src={reception} className="w-full h-[500px] object-cover" />

          <div className="absolute  inset-x-0 top-[360px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[22px] font-semibold tracking-widest">
              CELEBRATIONS
              </h1>

              <Link to="/receptions">
                {" "}
                <button className="mt-[30px] text-[16px]">
                  <div className="rounded-none border-[1.5px] border-white pt-[10px] pb-[10px] pl-[20px] pr-[20px]">
                    EXPLORE
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <p
        className={cls(
          "text-[14px] font-[description1] pl-[20px] pr-[20px] text-center",
          "xl:pl-[390px] xl:pr-[390px] xl:text-[14px]"
        )}
      >
        {" "}
        Crafting timeless memories with artistry and precision, we redefine
        wedding photography with innovation, elegance, and heartfelt
        storytelling. Every frame we capture is a celebration of love, tailored
        to create an unforgettable experience.
      </p>
      <div className="flex justify-center mb-[20px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>

      <div className="chat-icon">
        <DesktopWa/>
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
